<script setup lang="ts">
import PageFeedback from '@/components/PageFeedback/PageFeedback.vue';
import BasePage from '@/components/pages/BasePage/BasePage.vue';
import BasePageTitle from '@/components/pages/BasePage/BasePageTitle.vue';
import SimplePage from '@/components/pages/SimplePage/SimplePage.vue';
import { routenames } from '@/router/routenames';
import { useAuthenticationStore } from '@/stores/authenticationStore';
import { mdiMagnify } from '@mdi/js';

const authStore = useAuthenticationStore();
</script>

<template>
  <BasePage v-if="authStore.isAuthenticated">
    <template #title>
      <BasePageTitle :title="$t('PageNotFound')" />
    </template>
    <PageFeedback :icon="mdiMagnify" :message="$t('PageNotFoundMessage')" />
  </BasePage>

  <SimplePage v-else :headline="$t('PageNotFound')">
    <p className="mb-6">{{ $t('PageNotFoundMessage') }}</p>
    <v-btn color="secondary" :to="{ name: routenames.signIn }">{{ $t('GoToSignIn') }}</v-btn>
  </SimplePage>
</template>
